













































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Notify } from '@/helpers/Notify'
import { Api } from '@/fetch/Api'
import type { NavItem } from '@/interfaces'
import store from '@/store'

@Component
export default class SideBar extends Vue {
  callInProgress = false
  nav: NavItem[] = null
  is_admin = false
  show_email_integration = false
  booking_system_url = false
  domain = window.location.hostname.replace(/www./i, '')

  mounted() {
    this.fetchDomainNav()
  }

  public async fetchDomainNav() {
    this.callInProgress = true
    try {
      const domainNavResponse = await Api.getDomainNav()
      this.is_admin = domainNavResponse.is_admin
      this.nav = domainNavResponse.nav
      this.show_email_integration = domainNavResponse.show_email_integration
      this.booking_system_url = domainNavResponse.booking_system_url
      this.callInProgress = false
    } catch (e) {
      this.callInProgress = false
      Notify.create({
        type: 'error',
        title: 'Something went wrong...',
        text: e,
      })
    }
  }

  // watching for a reloadNav toggle to reload Nav
  get reloadNavFlag() {
    return store.state.flags.reloadNav
  }

  @Watch('reloadNavFlag')
  onVariable() {
    this.fetchDomainNav()
  }

  public async cloneSite(domain) {
    this.callInProgress = true
    try {
      const domainNavResponse = await Api.cloneSite(domain)
      this.callInProgress = false
      Notify.create({
        type: 'success',
        title: 'Cloned!',
        text: domainNavResponse.message,
      })
    } catch (e) {
      this.callInProgress = false
      Notify.create({
        type: 'error',
        title: 'Something went wrong...',
        text: e,
      })
    }
  }

  public comfirmClone(domain) {
    const h = this.$createElement
    this.$bvModal.msgBoxConfirm([h('span', { domProps: { innerHTML: 'Are you sure you want to clone the website contents to staff.webhealer.com ?!' } })], {
      title: [h('span', { domProps: { innerHTML: '<b>Clone Confirmation!</b>' } })],
      size: 'md',
      buttonSize: 'sm',
      okVariant: 'success',
      cancelVariant: 'danger',
      okTitle: 'Proceed',
      cancelTitle: 'Cancel',
      footerClass: 'p-2',
      hideHeaderClose: false,
      centered: true,
    }).then(value => {
      if (value) {
        this.cloneSite(domain)
      }
    }).catch(err => {
      alert(err)
    })
  }
}

